import React from 'react';
import CGamePage from './CGamePage';
import QuizPage from './QuizPage';

const CQuiz = () => <CGamePage gameKey="quiz" title="You Quiz" page={QuizPage} />;

export default CQuiz;
